import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "../Landing/Layout";
import insightsData, { MAIN_TABS, MORE_ITEMS, CATEGORY_MAP } from "./insightsData";
import "./insights.css";

const Insights = () => {
  const [active, setActive] = useState("All Posts");
  const [moreOpen, setMoreOpen] = useState(false);
  const moreRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handler = (e) => {
      if (moreRef.current && !moreRef.current.contains(e.target)) {
        setMoreOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // Filter logic: supports both direct category match and broad→specific mapping
  const filtered =
    active === "All Posts"
      ? insightsData
      : insightsData.filter((p) => {
        // Direct match (e.g. clicking "Pillar 1 — Self-Mastery in Professional Growth")
        if (p.category === active) return true;
        // Broad match via CATEGORY_MAP (e.g. "Self-Mastery in Leadership" maps to Pillar 1)
        const mapped = CATEGORY_MAP[active];
        if (mapped && mapped.includes(p.category)) return true;
        return false;
      });

  const isMoreActive = MORE_ITEMS.includes(active);

  return (
    <Layout>
      <div className="insights-page">
        {/* ── Hero ── */}
        <section className="insights-hero">
          <div className="section-container">
            <h1 className="heading-display">Insights</h1>
            <p className="insights-hero-sub">
              Perspectives on practice, leadership &amp; professional growth
            </p>
          </div>
        </section>

        {/* ── Category Tabs + More Dropdown ── */}
        <div className="insights-tabs">
          {MAIN_TABS.map((cat) => (
            <button
              key={cat}
              className={`insights-tab${active === cat ? " active" : ""}`}
              onClick={() => { setActive(cat); setMoreOpen(false); }}
            >
              {cat}
            </button>
          ))}

          {/* More dropdown */}
          <div className="insights-more-wrapper" ref={moreRef}>
            <button
              className={`insights-tab insights-more-btn${isMoreActive ? " active" : ""}`}
              onClick={() => setMoreOpen((prev) => !prev)}
            >
              More <span className="insights-more-arrow">{moreOpen ? "▲" : "▼"}</span>
            </button>
            {moreOpen && (
              <div className="insights-more-dropdown">
                {MORE_ITEMS.map((cat) => (
                  <button
                    key={cat}
                    className={`insights-more-item${active === cat ? " active" : ""}`}
                    onClick={() => { setActive(cat); setMoreOpen(false); }}
                  >
                    {cat}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* ── Active heading ── */}
        <div className="insights-active-heading">
          <h2>{active}</h2>
        </div>

        {/* ── Card Grid ── */}
        {filtered.length === 0 ? (
          <div className="insights-empty">No posts in this category yet.</div>
        ) : (
          <div className="insights-grid">
            {filtered.map((post) => (
              <Link
                key={post.id}
                to={`/insights/${post.slug}`}
                className="insight-card"
              >
                <div className="insight-card-body">
                  <div className="insight-card-meta-top">
                    <span>{post.readTime}</span>
                  </div>
                  <div className="insight-card-cat">{post.category}</div>
                  <h2 className="insight-card-title">{post.title}</h2>
                  <p className="insight-card-excerpt">{post.excerpt}</p>
                  <span className="insight-card-link">Read more &rarr;</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Insights;
